import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet framework
import { devConfig, profile, countries } from 'config/config'; // Importing configuration constants from config module

/**
 * Class representing a view for filtering agents in a tree structure.
 * @extends JetView
 */
export default class FilterAgentsTreeView extends JetView {
    /**
     * Defines the configuration for the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Define the layout for the left section of the UI
        const left = {
            margin: 5, // Margin around the left section
            id: 'a1', // Unique identifier for the left section
            rows: [
                // Array of rows in the left section
                {
                    margin: 15, // Margin around the row
                    css: 'on-row', // CSS class for styling the row
                    responsive: 'a1', // Responsive design identifier
                    cols: [
                        // Array of columns in the row
                        {
                            view: 'text', // Type of UI component
                            name: 'UserId', // Name of the input field
                            type: 'number', // Input type
                            minWidth: 200, // Minimum width of the input field
                            // Label for the input field with an icon
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction(
                                // Determine visibility based on permissions
                                'filterByUser',
                                'Add',
                            ),
                            css: 'prm-filterByUser', // CSS class for styling
                            labelPosition: 'top', // Position of the label
                            placeholder: _('ID Usuario'), // Placeholder text
                        },
                        {
                            view: 'text', // Type of UI component
                            name: 'Login', // Name of the input field
                            minWidth: 200, // Minimum width of the input field
                            // Label for the input field with an icon
                            label: "<span class='icon-mail'></span>" + _('Usuario (Correo electrónico)'),
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Usuario (Correo electrónico)'), // Placeholder text
                            hidden: !devConfig.getPermAction(
                                // Determine visibility based on permissions
                                'filterByUser',
                                'Add',
                            ),
                            css: 'prm-filterByUser', // CSS class for styling
                        },
                        {
                            view: 'text', // Type of UI component
                            name: 'Name', // Name of the input field
                            minWidth: 200, // Minimum width of the input field
                            // Label for the input field with an icon
                            label: "<span class='icon-user'></span>" + _('Nombre'),
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Nombre'), // Placeholder text
                            hidden: !devConfig.getPermAction(
                                // Determine visibility based on permissions
                                'filterByUser',
                                'Add',
                            ),
                            css: 'prm-filterByUser', // CSS class for styling
                        },
                        {
                            view: 'combo', // Type of UI component
                            name: 'BetShopId', // Name of the input field
                            minWidth: 200, // Minimum width of the input field
                            // Label for the input field with an icon
                            label: "<span class='icon-shop'></span>" + _('Punto de Venta'),
                            hidden: !devConfig.getPermAction(
                                // Determine visibility based on permissions
                                'filterByBetShop',
                                'Add',
                            ),
                            css: 'prm-filterByBetShop', // CSS class for styling
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            id: 'BetShopId', // Unique identifier for the combo
                            options: {
                                // Options for the combo
                                body: {
                                    // Function to fetch data for the combo based on user input
                                    dataFeed: function (text) {
                                        var vthis = this; // Reference to the current context
                                        if (text.length > 2) {
                                            // Trigger data fetch if input length is greater than 2
                                            webix
                                                .ajax() // Initiate an AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + // API endpoint
                                                        'es/Select/BetShopsSelect',
                                                    '{"Filter":"' + text + '"}', // Request payload
                                                    {
                                                        error: function (
                                                            // Error callback
                                                            text,
                                                            data,
                                                            XmlHttpRequest,
                                                        ) {
                                                            webix.message(
                                                                // Display error message
                                                                'Error! ',
                                                            );
                                                        },
                                                        success: function (
                                                            // Success callback
                                                            text,
                                                            data,
                                                            XmlHttpRequest,
                                                        ) {
                                                            var resp = JSON.parse(
                                                                // Parse the response
                                                                text,
                                                            );
                                                            if (
                                                                !resp.HasError // Check for errors in the response
                                                            ) {
                                                                vthis.parse(
                                                                    // Parse the data into the combo
                                                                    resp.Data,
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                    ],
                },
                {
                    margin: 15, // Margin around the row
                    css: 'on-row', // CSS class for styling the row
                    responsive: 'a1', // Responsive design identifier
                    cols: [
                        // Array of columns in the row
                        {
                            view: 'text', // Type of UI component
                            name: 'UserIdAgent', // Name of the input field
                            type: 'number', // Input type
                            minWidth: 200, // Minimum width of the input field
                            // Label for the input field with an icon
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Concesionario'),
                            labelPosition: 'top', // Position of the label
                            placeholder: _('ID Concesionario'), // Placeholder text
                            hidden: !devConfig.getPermAction(
                                // Determine visibility based on permissions
                                'filterByAgent',
                                'Add',
                            ),
                            css: 'prm-filterByAgent', // CSS class for styling
                        },
                        {
                            view: 'text', // Type of UI component
                            name: 'UserIdAgent2', // Name of the input field
                            type: 'number', // Input type
                            minWidth: 200, // Minimum width of the input field
                            // Label for the input field with an icon
                            label: "<span class='icon-drivers-license-o'></span>" + _('Subconcesionario'),
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Subconcesionario'), // Placeholder text
                            hidden: !devConfig.getPermAction(
                                // Determine visibility based on permissions
                                'filterByAgent2',
                                'Add',
                            ),
                            css: 'prm-filterByAgent2', // CSS class for styling
                        },
                        {
                            view: 'richselect', // Type of UI component
                            name: 'CountrySelect', // Name of the input field
                            id: 'CountrySelect', // Unique identifier for the rich select
                            // Label for the input field with an icon
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top', // Position of the label
                            minWidth: 200, // Minimum width of the input field
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                // Options for the rich select
                                body: {
                                    // Template for displaying options
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for the options
                                },
                            },
                            // Determine visibility based on permissions and configuration
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'prm-filterByCountry', // CSS class for styling
                        },
                        {
                            view: 'richselect', // Type of UI component
                            name: 'CountrySelect2', // Name of the input field
                            // Label for the input field with an icon
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top', // Position of the label
                            minWidth: 200, // Minimum width of the input field
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: profile.Settings.ReportCountry, // Default value from profile settings
                            readonly: true, // Make the field read-only
                            options: {
                                // Options for the rich select
                                body: {
                                    // Template for displaying options
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for the options
                                },
                            },
                            // Determine visibility based on permissions and configuration
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'),
                            css: 'country-hide prm-filterByCountry', // CSS class for styling
                        },
                        { id: 'grav2', gravity: 1, minWidth: 200 }, // Gravity element for layout management
                    ],
                },
            ],
        };
        /**
         * Configuration object for the upper section of the UI.
         * @type {Object}
         * @property {string} css - CSS class for styling the container.
         * @property {Array} rows - Array of row configurations.
         */
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10, // Margin around the row
                    cols: [left], // Columns within the row
                },
            ],
        };

        /**
         * Configuration object for a second upper section of the UI.
         * @type {Object}
         * @property {string} css - CSS class for styling the container.
         * @property {Array} rows - Array of row configurations.
         */
        const upper_section2 = {
            css: 'father-container',
            rows: [
                {
                    margin: 10, // Margin around the row
                    cols: [
                        // Columns within the row
                    ],
                },
            ],
        };

        /**
         * Configuration object for a button section in the UI.
         * @type {Object}
         * @property {number} margin - Margin around the button section.
         * @property {Array} cols - Array of button configurations.
         */
        const buttons = {
            margin: 10, // Margin around the button section
            cols: [
                {}, // Placeholder for a column
                {
                    view: 'button', // Type of UI element
                    value: _('Limpiar'), // Button label (translated)
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        // Click event handler
                        this.getRoot().clear(); // Clear the root component
                    },
                },
                {
                    view: 'button', // Type of UI element
                    value: _('Consultar'), // Button label (translated)
                    hotkey: 'enter', // Keyboard shortcut for the button
                    type: 'form', // Button type
                    autowidth: true, // Automatically adjust width
                    click: () => {
                        // Click event handler
                        const filterdata = this.getRoot().getValues(); // Get values from the root component
                        if (devConfig.getCountryReport()) {
                            // Check if country report is enabled
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country filter
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary filter
                        this.app.callEvent('agentTree:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse a UI element
                        $$('a5').scrollTo(100, 0); // Scroll to a specific position
                    },
                },
            ],
        };
        const buttons2 = {
            /**
             * Margin applied to the button container.
             * @type {number}
             */
            margin: 10,

            /**
             * Array of button configurations.
             * @type {Array<Object>}
             */
            cols: [
                {}, // Placeholder for potential future button configuration.
                {
                    /**
                     * Button to clear the form.
                     * @type {Object}
                     */
                    view: 'button',
                    value: _('Limpiar'), // Localized button label for 'Clear'.
                    width: 100,

                    /**
                     * Click event handler for the clear button.
                     * Resets the form values and specific fields.
                     */
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Resets form to clean values.
                        $$('CountrySelect').setValue(
                            $$('myForm2').getCleanValues().CountrySelect, // Sets CountrySelect to the cleaned value.
                        );
                        $$('Datepicker').setValue(''); // Clears the date picker field.
                    },
                },
                {
                    /**
                     * Button to submit the form for consultation.
                     * @type {Object}
                     */
                    view: 'button',
                    value: _('Consultar'), // Localized button label for 'Consult'.
                    hotkey: 'enter', // Allows form submission with the Enter key.
                    type: 'form', // Indicates this button submits the form.
                    width: 110,

                    /**
                     * Click event handler for the consult button.
                     * Gathers form data and triggers a filtering event.
                     */
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Retrieves current form values.
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Sets CountrySelect based on profile settings if applicable.
                        }
                        delete filterdata['CountrySelect2']; // Removes unnecessary field from filter data.
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Ensures CountrySelect is set again if applicable.
                        }
                        delete filterdata['CountrySelect2']; // Ensures CountrySelect2 is removed again.
                        this.app.callEvent('agentTree:filter', [filterdata]); // Triggers the filtering event with the collected data.
                    },
                },
            ],
        };
        /**
         * Represents the configuration for an accordion section.
         * @type {Object}
         * @property {string} id - Unique identifier for the accordion section.
         * @property {Array} rows - Array of rows contained within the accordion section.
         * @property {boolean} rows.multi - Indicates if multiple items can be expanded.
         * @property {string} rows.view - The type of view for the accordion.
         * @property {string} rows.css - CSS class for styling the accordion.
         * @property {boolean} rows.collapsed - Initial state of the accordion (collapsed or expanded).
         * @property {number} rows.paddingY - Vertical padding for the accordion.
         * @property {string} rows.type - Type of the accordion layout.
         * @property {Array} rows.rows - Nested rows within the accordion.
         */
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [],
                },
            ],
        };

        /**
         * Represents the configuration for a second accordion section.
         * @type {Object}
         * @property {string} type - Type of the accordion layout (wide).
         * @property {Array} rows - Array of rows contained within the accordion section.
         * @property {boolean} rows.multi - Indicates if multiple items can be expanded.
         * @property {string} rows.view - The type of view for the accordion.
         * @property {string} rows.css - CSS class for styling the accordion.
         * @property {boolean} rows.collapsed - Initial state of the accordion (collapsed or expanded).
         * @property {Array} rows.rows - Nested rows within the accordion.
         * @property {Object} rows.rows[0].header - Header for the accordion item.
         * @property {string} rows.rows[0].id - Unique identifier for the accordion item.
         * @property {Object} rows.rows[0].body - Body configuration of the accordion item.
         * @property {number} rows.rows[0].body.padding - Padding for the body of the accordion item.
         * @property {Array} rows.rows[0].body.rows - Array of rows contained within the body of the accordion item.
         */
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Translated header for the accordion item.
                            id: 'b6',
                            body: {
                                padding: 10, // Padding for the body of the accordion item.
                                rows: [
                                    upper_section, // Reference to an upper section component.
                                    accordion_section, // Reference to the first accordion section.
                                    buttons, // Reference to a buttons component.
                                ],
                            },
                        },
                    ],
                },
            ],
        };
        /**
         * Configuration object for the accordion section.
         * @type {Object}
         * @property {number} padding - Padding around the accordion section.
         * @property {Array} rows - Array containing the components of the accordion section.
         */
        const accordion_section3 = {
            padding: 10,
            rows: [upper_section, accordion_section, buttons2],
        };

        /**
         * Creates a filter popup window using Webix UI.
         * @type {Object}
         * @property {string} view - Type of the UI component, in this case, a window.
         * @property {boolean} move - Allows the window to be moved.
         * @property {string} id - Unique identifier for the popup window.
         * @property {boolean} fullscreen - Indicates if the window should take the full screen.
         * @property {Object} head - Header configuration for the window.
         * @property {boolean} modal - Indicates if the window is modal.
         * @property {string} position - Position of the window on the screen.
         * @property {Object} body - Body configuration of the window.
         */
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    /** Label for the filter title */
                    { view: 'label', label: _('Filtros'), align: 'center' },
                    {
                        /** Icon button to close the popup */
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            /** Hides the popup window when the icon is clicked */
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'scrollview',
                scroll: 'xy',
                body: {
                    view: 'form',
                    id: 'myForm2',
                    type: 'clean',
                    rows: [accordion_section3],
                    /** Validation rules for the form */
                    rules: {
                        fname: webix.rules.isNotEmpty, // Ensures the 'fname' field is not empty
                    },
                },
            },
        });
        return {
            /**
             * Defines the view type as a form.
             * @type {string}
             */
            view: 'form',

            /**
             * Unique identifier for the form.
             * @type {string}
             */
            id: 'myForm',

            /**
             * Specifies the form type as 'clean', which indicates a clean layout.
             * @type {string}
             */
            type: 'clean',

            /**
             * Contains the layout rows of the form.
             * The content of the rows is determined by the screen width.
             * @type {Array}
             */
            rows: [
                screen.width > 500
                    ? accordion_section2 // Displays accordion_section2 if screen width is greater than 500
                    : { height: 1, minWidth: 200 }, // Otherwise, provides a minimal height and width
            ],

            /**
             * Validation rules for the form fields.
             * @type {Object}
             */
            rules: {
                /**
                 * Rule for the 'fname' field to ensure it is not empty.
                 * @type {Function}
                 */
                fname: webix.rules.isNotEmpty,
            },
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view with the provided grid.
     * @param {Object} grid - The grid instance to be initialized.
     */
    init(grid) {
        // Wait for the Webix library to be ready
        webix.ready(function () {
            // Check if the screen width is less than 500 pixels
            if (screen.width < 500) {
                // Hide the UI component with the ID 'grav2' if the condition is met
                $$('grav2').hide();
            }
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
